import React, { FunctionComponent, useCallback, useMemo, useState } from "react"
import { unstable_batchedUpdates } from "react-dom"
import { handleUpload } from "../../store/data/actions"
import PureImage from "../Image/PureImage"
import ProgressBar from "../ProgressBar/ProgressBar"
import s from "./Upload.less"

interface iProps {
  file: File
  fileCollection: string
  addFile: (_id: string, name: string) => void
  removeFile: (_id: string) => void
}

interface iProgress {
  loaded: number
  total: number
}

const NewFile: FunctionComponent<iProps> = ({
  file,
  fileCollection,
  addFile,
  removeFile,
}) => {
  const [_id, setId] = useState<string>("")
  const [image, setImage] = useState<string>("")
  const [progress, setProgress] = useState(0)
  const [uploading, setUploading] = useState(false)

  const onProgress = useCallback((currentProgress: iProgress) => {
    setProgress(
      parseFloat(
        ((currentProgress.loaded / currentProgress.total) * 100).toFixed(2),
      ),
    )
  }, [])

  useMemo(() => {
    if (file.type.includes("image")) {
      const reader = new FileReader()
      reader.onload = () => {
        setImage(reader.result as string)
      }
      reader.readAsDataURL(file)
    }
    unstable_batchedUpdates(() => {
      setProgress(0)
      setUploading(true)
    })
    handleUpload({ file, fileCollection, onProgress }).then(({ _id }) => {
      setId(_id)
      addFile(_id, file.name)
      setUploading(false)
    })
  }, [])

  const handleRemoveFile = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.stopPropagation()
    confirm("Are you sure you want to remove it?") && removeFile(_id)
  }

  return (
    <div className={s.singleFile}>
      <div className={s.imageHolder}>
        <PureImage src={image} />
      </div>
      <div className={s.info}>
        <div>
          <p>{file.name}</p>
          <p>{Math.round((file.size || 0) / 1024)} KB</p>
          {uploading && <ProgressBar progress={progress} />}
        </div>
        <div className={s.btnWrap}>
          <button type="button" onClick={handleRemoveFile}>
            Remove
          </button>
        </div>
      </div>
    </div>
  )
}

export default NewFile
